/* eslint-disable no-useless-escape */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable consistent-return */
/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
import React, {
  ChangeEvent,
  forwardRef,
  useEffect,
  useRef,
  useState,
} from 'react';
import { TransitionProps } from '@mui/material/transitions';
import {
  // Backdrop,
  Button,
  // CircularProgress,
  Dialog, DialogContent, DialogTitle, FormControl, FormControlLabel, Grid, IconButton, Input, Radio, RadioGroup, Zoom,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
// import { Editor } from 'react-draft-wysiwyg';
// import { stateToHTML } from 'draft-js-export-html';
// import { ContentState, EditorState } from 'draft-js';
// import htmlToDraft from 'html-to-draftjs';
import { yupResolver } from '@hookform/resolvers/yup';
import { ObjectSchema } from 'yup';
import Editor, { ContentEditableEvent } from 'react-simple-wysiwyg';
import { useParams } from 'react-router-dom';
import { AxiosError } from 'axios';
import ComponentTextInput from '../../../Common/ComponentTextinput/ComponentTextInput';
import RequiredFiled from '../../../Common/RequiredField';
import { GetUserDetailsPayload, SendEmailFormValues, TypesSendEmailDialogBox } from '../utils/types';
import {
  radioOptions, SendEmailForm, sendEmailSchema, SendMailDefaultValue,
} from '../utils/helper';
// import { customOptions } from '../../../Common/TextEditorOptions';
import { AttachmentIcon } from '../../../assets/TableIcons/AttachmentIcon';
import {
  clearIsEmailSent, clearUserDetailsList, getUserDetailsListStart, sendEmailStart,
} from '../redux/sliceReportWorkspace';
import { RootState } from '../../../redux/rootState';
import styles from '../utils/reportingStyle.module.scss';
// import { showSuccessToaster } from '../../../Common/ComponentToast/ComponentSuccessToasts';
import { addJobOrderEmailFlag } from '../../oilReport/redux/oilReportSlice';
import ConfirmationModal from '../../../Common/ConfirmationModal/ConfirmationModal';
import { ConfirmationIcon } from '../../../assets/Icons/AnalystIcons/ConfirmationIcon';
import english from '../../../assets/lang/english';
import { showErrorToaster } from '../../../Common/ComponentToast/ComponentSuccessToasts';
import localStorageConstants from '../../../utils/LocalStorageConstants';
import Config from '../../../Common/Config';
import { makeExtPostRequest } from '../../../Common/NetworkOps';
import { OilReportEmailResponse } from '../../../Common/OilReportEmailModal/TypeOilReportEmailModal';
import { setLoader } from '../../../redux/loaderSlice';

const Transition = forwardRef((
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) => <Zoom ref={ref} {...props} />);

function ComponentSendEmailModel({
  show, setOpenFrom, emailsData, handleClear,
}: TypesSendEmailDialogBox): JSX.Element {
  const dispatch = useDispatch();
  const path = window.location.href;
  const { UserDetailsData, isEmailSent } = useSelector((state: RootState) => state.reportWorkspaceReducer);
  const { isJOFlagAdded } = useSelector((state: RootState) => state.oilReportReducer);
  // const { userProfile } = useSelector((state: RootState) => state.userProfileReducer);

  const [comment, setComment] = useState<string>('');
  const [showManualInput, setShowManualInput] = useState(false);
  const [fileValidationModal, setFileValidationModal] = useState<boolean>(false);
  const [radioVal, setRadioVal] = useState<string>('1');
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [plainText, setPlainText] = useState<string>('');
  const [sendMailLoading, setSendMailLoading] = useState(false);
  const MAX_CHARACTER_LIMIT = 3000;
  const { id } = useParams();

  const {
    control, formState: { errors }, handleSubmit, setValue,
  } = useForm<SendEmailFormValues>({
    defaultValues: SendMailDefaultValue as unknown as SendEmailFormValues,
    resolver: yupResolver(sendEmailSchema as ObjectSchema<SendEmailFormValues>),
  });

  useEffect(() => {
    dispatch(setLoader(sendMailLoading));
  }, [sendMailLoading]);
  // no need of setting cc as email is not sent through outlook
  // useEffect(() => {
  //   setValue('cc', userProfile?.Email?.trim());
  // }, [userProfile]);

  useEffect(() => {
    if (UserDetailsData?.SubjectComments) {
      const data = radioOptions?.find((item) => item?.value === String(UserDetailsData?.SubjectComments));
      switch (data?.value) {
        case '2':
          setValue(SendEmailForm.subject, `${UserDetailsData?.SiteName || ''} _ ${UserDetailsData?.SerialNumber || ''} - ${data.label}`);
          break;
        case '3':
          setValue(SendEmailForm.subject, `${UserDetailsData?.SiteName || ''} _ ${UserDetailsData?.SerialNumber || ''} - ${data.label}`);
          break;
        case '4':
          setValue(SendEmailForm.subject, `${UserDetailsData?.SiteName || ''} _ ${UserDetailsData?.SerialNumber || ''} - ${data.label}`);
          break;
        case '5':
          setValue(SendEmailForm.subject, `${UserDetailsData?.SiteName || ''} _ ${UserDetailsData?.SerialNumber || ''} - ${data.label}`);
          break;
        default:
          setValue(SendEmailForm.subject, `${UserDetailsData?.SiteName || ''} _ ${UserDetailsData?.SerialNumber || ''}`);
          break;
      }

      const body = `Your latest report from TAI Services is attached. If
you have received a PDF file, the Adobe Reader will allow you to open, view and print the test
results. After reviewing your report, if you have technical questions, call (800) 554-4127. Ask for
Michael Johnson Or Ray Bernstein. If you have a Logo your company uses, or would like to change
the logo being used, preferably on a white background, we could use it on your reports.
Please email it to us and we will customize your reports.<br /><br />
We appreciate your business and look forward to being of service to your Company again.<br /><br />
Thank you for using TAI Services, Inc.<br />
Macy Hall<br />
Technical Services Coordinator<br />
TAI Services, Inc.<br /><br />
This report is for unit ${UserDetailsData?.SerialNumber}, located at ${UserDetailsData?.SiteName}`;

      setComment(body);
      setRadioVal(String(UserDetailsData?.SubjectComments));
    }
  }, [UserDetailsData]);

  const handleClose = () => {
    setSelectedFile(null);
    handleClear();
    setOpenFrom();
  };

  const fileInputRef = useRef(null);
  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { files } = event.target;
    if (files && files.length > 0) {
      const selected = files[0];
      const fileExtension = selected.name.split('.').pop()?.toLowerCase();
      // const fileSizeInKB = selected.size / 1024; // Convert bytes to KB

      const allowedExtensions = ['pdf'];
      // const maxSizeInKB = 5120; // 5 MB = 5120 KB

      if (!allowedExtensions.includes(fileExtension || '')) {
        showErrorToaster('Invalid file format. Please upload a PDF file (.pdf).');
      // } else if (fileSizeInKB > maxSizeInKB) {
      //   showErrorToaster('File size exceeds 5MB. Please upload a smaller PDF.');
      } else {
        setSelectedFile(selected);
        setShowManualInput(true);
        // showSuccessToaster('File attached successfully');
      }
    }
  };

  useEffect(() => {
    if (selectedFile && selectedFile?.name !== `${UserDetailsData?.SiteName?.replace(/[\r\n]+/g, ' ')?.trim()?.replace(/[\/\\:*?"<>|]/g, '_') || ''}_${UserDetailsData?.SerialNumber?.replace(/[\/\\:*?"<>|]/g, '_') || ''}_${UserDetailsData?.UnitId}.pdf`) {
      setFileValidationModal(true);
    }
  }, [selectedFile]);

  useEffect(() => {
    setValue(SendEmailForm.to, emailsData);
  }, [emailsData]);

  const handleComment = (event: ContentEditableEvent) => {
    const htmlContent = event.target.value;
    const tempDivElement = document.createElement('div');
    tempDivElement.innerHTML = htmlContent;
    const plainTextContent = tempDivElement.textContent || tempDivElement.innerText || '';

    if (plainTextContent.length <= MAX_CHARACTER_LIMIT) {
      setComment(htmlContent);
      setPlainText(plainTextContent);
    }
  };

  const handleSendEmailError = (error: AxiosError<OilReportEmailResponse>) => {
    if (error?.response?.data?.BMT?.ResponseCode === 500) {
      showErrorToaster(error?.response?.data?.BMT?.ResponseMessage);
    }
  };

  useEffect(() => {
    const tempDivElement = document.createElement('div');
    tempDivElement.innerHTML = comment;
    const plainTextContent = tempDivElement.textContent || tempDivElement.innerText || '';

    if (plainTextContent.length <= MAX_CHARACTER_LIMIT) {
      setComment(comment);
      setPlainText(plainTextContent);
    }
  }, [comment]);

  const onSubmit = (values: SendEmailFormValues) => {
    if (showManualInput && selectedFile === null) {
      showErrorToaster('Please attach PDF to send mail.');
      return;
    }

    const formData = new FormData();

    if (selectedFile) {
      formData.append('File', selectedFile);
    }
    formData.append('fileName', `${UserDetailsData?.SiteName?.replace(/[\r\n]+/g, ' ')?.trim()?.replace(/[\/\\:*?"<>|]/g, '_') || ''}_${UserDetailsData?.SerialNumber?.replace(/[\/\\:*?"<>|]/g, '_') || ''}_${UserDetailsData?.UnitId}.pdf`);
    formData.append('RecieverMail', values.to ?? '');
    formData.append('Subject', values.subject ?? '');
    formData.append('Body', comment ?? '');
    formData.append('CcMail', values.cc ?? '');
    formData.append('Type', '3');
    dispatch(sendEmailStart({ formData, callback: () => setShowManualInput(true) }));
    // handleClose();
  };

  const fetchFile = async () => {
    try {
      setSendMailLoading(true);

      const pay = {
        fileName: `${UserDetailsData?.SiteName?.replace(/[\r\n]+/g, ' ')?.trim()?.replace(/[\/\\:*?"<>|]/g, '_') || ''}_${UserDetailsData?.SerialNumber?.replace(/[\/\\:*?"<>|]/g, '_') || ''}_${UserDetailsData?.UnitId}.pdf`,
        type: 3,
      };

      const token = localStorage.getItem(localStorageConstants.TOKEN);
      const userID = localStorage.getItem(localStorageConstants.USER_ID);

      if (!token || !userID) {
        throw new Error('Token or user ID is missing');
      }

      const axiosConfig = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `bearer ${token}`,
          LoginUserId: userID,
        },
      };

      const url = Config.oilReport.downloadAttachment;

      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const result = await makeExtPostRequest(url, pay, axiosConfig);

      setSendMailLoading(false);
      dispatch(setLoader(false));
      return;
    } catch (error) {
      const axiosError = error as AxiosError<OilReportEmailResponse>;
      if (axiosError?.response?.data?.BMT?.ResponseCode === 404 && axiosError?.response?.data?.BMT?.Result === 'File not found') {
        showErrorToaster('File not found. Please upload the PDF file manually.');
        setShowManualInput(true);
      } else if (axiosError?.response?.data?.BMT?.ResponseCode === 500 && axiosError?.response?.data?.BMT?.Result === 'Folder not found') {
        showErrorToaster('File or folder does not exist. Please upload the PDF file manually.');
        setShowManualInput(true);
      } else if (axiosError?.response?.data?.BMT?.ResponseCode === 400 && axiosError?.response?.data?.BMT?.ResponseMessage === 'BadRequest') {
        showErrorToaster(axiosError?.response?.data?.BMT?.Result || 'You are not authorized. Kindly contact admin.');
        setShowManualInput(true);
      } else {
        handleSendEmailError(axiosError);
        setShowManualInput(true);
      }
      setSendMailLoading(false);
    }
  };

  useEffect(() => {
    if (UserDetailsData?.SiteName) {
      fetchFile();
    }
  }, [UserDetailsData]);

  const onDownloadEmail = async () => {
    try {
      setSendMailLoading(true);

      const pay = {
        fileName: `${UserDetailsData?.SiteName?.replace(/[\r\n]+/g, ' ')?.trim()?.replace(/[\/\\:*?"<>|]/g, '_') || ''}_${UserDetailsData?.SerialNumber?.replace(/[\/\\:*?"<>|]/g, '_') || ''}_${UserDetailsData?.UnitId}.pdf`,
        type: 3,
      };

      const token = localStorage.getItem(localStorageConstants.TOKEN);
      const userID = localStorage.getItem(localStorageConstants.USER_ID);

      if (!token || !userID) {
        throw new Error('Token or user ID is missing');
      }

      const axiosConfig = {
        responseType: 'blob' as const,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `bearer ${token}`,
          LoginUserId: userID,
        },
      };

      const url = Config.oilReport.downloadAttachment;

      const result = await makeExtPostRequest(url, pay, axiosConfig);
      const pdfBlob = result.data instanceof Blob
        ? result.data
        : new Blob([result.data as ArrayBuffer], { type: 'application/pdf' });
      const downloadUrl = window.URL.createObjectURL(pdfBlob);
      const downloadLink = document.createElement('a');
      downloadLink.href = downloadUrl;
      downloadLink.download = pay.fileName;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      downloadLink.remove();
      window.URL.revokeObjectURL(downloadUrl);

      setSendMailLoading(false);
      dispatch(setLoader(false));
    } catch (error) {
      const axiosError = error as AxiosError<OilReportEmailResponse>;
      if (axiosError?.response?.data?.BMT?.ResponseCode === 404 && axiosError?.response?.data?.BMT?.Result === 'File not found') {
        showErrorToaster('File not found. Please upload the PDF file manually.');
        setShowManualInput(true);
      } else if (axiosError?.response?.data?.BMT?.ResponseCode === 500 && axiosError?.response?.data?.BMT?.Result === 'Folder not found') {
        showErrorToaster('File or folder does not exist. Please upload the PDF file manually.');
        setShowManualInput(true);
      } else if (axiosError?.response?.data?.BMT?.ResponseCode === 400 && axiosError?.response?.data?.BMT?.ResponseMessage === 'BadRequest') {
        showErrorToaster(axiosError?.response?.data?.BMT?.Result || 'You are not authorized. Kindly contact admin.');
      } else {
        handleSendEmailError(axiosError);
      }
      setSendMailLoading(false);
    }
  };

  useEffect(() => {
    if (isEmailSent) {
      if (path.includes('job-order')) {
        handleClose();
      } else {
        dispatch(clearIsEmailSent());
        const payload = {
          jobOrder: id || '',
        };
        dispatch(addJobOrderEmailFlag(payload));
      }
    }
  }, [isEmailSent]);

  useEffect(() => {
    if (isJOFlagAdded) {
      handleClose();
    }
  }, [isJOFlagAdded]);

  const handleTestTypeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setRadioVal(e.target.value);
    const data = radioOptions.find((item) => item.value === e.target.value);
    switch (data?.value) {
      case '2':
        setValue(SendEmailForm.subject, `${UserDetailsData?.SiteName || ''} _ ${UserDetailsData?.SerialNumber || ''} - ${data.label}`);
        break;
      case '3':
        setValue(SendEmailForm.subject, `${UserDetailsData?.SiteName || ''} _ ${UserDetailsData?.SerialNumber || ''} - ${data.label}`);
        break;
      case '4':
        setValue(SendEmailForm.subject, `${UserDetailsData?.SiteName || ''} _ ${UserDetailsData?.SerialNumber || ''} - ${data.label}`);
        break;
      case '5':
        setValue(SendEmailForm.subject, `${UserDetailsData?.SiteName || ''} _ ${UserDetailsData?.SerialNumber || ''} - ${data.label}`);
        break;
      default:
        setValue(SendEmailForm.subject, `${UserDetailsData?.SiteName || ''} _ ${UserDetailsData?.SerialNumber || ''}`);
        break;
    }
  };

  useEffect(() => {
    const payload = {
      jobOrderId: id,
    };
    dispatch(getUserDetailsListStart(payload as GetUserDetailsPayload));

    return () => {
      dispatch(clearUserDetailsList());
    };
  }, []);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Dialog
        maxWidth="lg"
        PaperProps={{
          className: 'paperStyle',
        }}
        open={show}
        transitionDuration={500}
        TransitionComponent={Transition}
        keepMounted
        onClose={setOpenFrom}
        onClick={(e) => e.stopPropagation()}
      >
        {/* {
        isLoading && (
        <Backdrop
          sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
        >
          <CircularProgress />
        </Backdrop>
        )
        } */}
        <DialogTitle className="modalHeaderTitle">
          Send Email
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
          <div className="div_label_text" style={{ marginTop: '10px', paddingTop: '10px', borderTop: '1px solid rgb(211, 209, 209)' }}>
            <label className="label_Style_job" style={{ marginBottom: '-5px' }}>Subject Comments</label>
            <FormControl>
              <RadioGroup
                row
                value={radioVal}
                onChange={(event) => {
                  handleTestTypeChange(event);
                }}
              >
                {radioOptions.map((option) => (
                  <div className="type_of_test" key={option.value}>
                    <FormControlLabel
                      labelPlacement="start"
                      value={option.value}
                      control={<Radio color="success" />}
                      label={<span className="radio_button_style">{option.label}</span>}
                    />
                  </div>
                ))}
              </RadioGroup>
            </FormControl>
          </div>
        </DialogTitle>
        <DialogContent className={styles.DialogContentStyle}>
          <form noValidate>
            <Grid container spacing={2}>
              <Grid item md={12} sm={12} xs={12}>
                <div className="div_label_text">
                  <label className="label_Style_job">
                    To:
                    <RequiredFiled />
                  </label>
                  <ComponentTextInput
                    control={control}
                    className="nonCapitalizeField"
                    name={SendEmailForm.to}
                    size="small"
                    id={SendEmailForm.to}
                    inputProps={{ maxLength: 250 }}
                    errors={errors}
                  />
                </div>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <div className="div_label_text">
                  <label className="label_Style_job">CC:</label>
                  <ComponentTextInput
                    control={control}
                    className="nonCapitalizeField"
                    name={SendEmailForm.cc}
                    size="small"
                    id={SendEmailForm.cc}
                    errors={errors}
                    inputProps={{ maxLength: 250 }}
                  />
                </div>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <div className="div_label_text">
                  <label className="label_Style_job">
                    Subject:
                    <RequiredFiled />
                  </label>
                  <ComponentTextInput
                    control={control}
                    className="nonCapitalizeField"
                    name={SendEmailForm.subject}
                    size="small"
                    id={SendEmailForm.subject}
                    errors={errors}
                    inputProps={{ maxLength: 500 }}
                  />
                </div>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Input
                    type="file"
                    inputProps={{ accept: '.pdf', style: { display: 'none' } }}
                    id="fileInputEmail"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    // disabled={!showManualInput}
                  />
                  <label htmlFor="fileInputEmail">
                    {/* <Button className="button_save_and_next" component="span" style={{ cursor: !showManualInput ? 'not-allowed' : 'pointer' }}> */}
                    <Button className="button_save_and_next" component="span">
                      <AttachmentIcon />
                    </Button>
                  </label>
                </div>
                <div className={styles.pdfFileName}>
                  <label>{selectedFile?.name}</label>
                  {!showManualInput && (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1px' }}>
                      <label className="head">{`${UserDetailsData?.SiteName?.replace(/[\r\n]+/g, ' ')?.trim()?.replace(/[\/\\:*?"<>|]/g, '_') || ''}_${UserDetailsData?.SerialNumber?.replace(/[\/\\:*?"<>|]/g, '_') || ''}_${UserDetailsData?.UnitId}.pdf`}</label>
                      <label className={styles.down} onClick={onDownloadEmail}>Download</label>
                    </div>
                  )}
                </div>
                <div className={styles.SendEmailEditor}>
                  <Editor value={comment} onChange={handleComment} tagName="p" />
                </div>
                <div className={styles.CharacterCount}>
                  <span>
                    {plainText?.length}
                    /
                    {MAX_CHARACTER_LIMIT}
                    {' '}
                    Characters
                  </span>
                </div>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <div className="save_and_next_div">
                  <div>
                    <Button className="button_cancel" onClick={handleClose}>Cancel</Button>
                  </div>
                  <div className="button_margin_left">
                    <Button type="submit" className="button_save_and_next">Send Email</Button>
                  </div>
                </div>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
      </Dialog>
      {fileValidationModal && (
        <ConfirmationModal
          readOnly
          show={fileValidationModal}
          setOpenFrom={() => setFileValidationModal(false)}
          // eslint-disable-next-line max-len
          text={english.FileValidationMsg}
          confirmationIcon={<ConfirmationIcon />}
        />
      )}
    </form>
  );
}

export default ComponentSendEmailModel;
